const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Returns true if the value is a valid UUID format.
 * Rejects undefined, null, empty string, "undefined", "null", and malformed strings.
 */
export function isValidUuid(value: string | null | undefined): boolean {
  if (value == null || typeof value !== 'string') {
    return false;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 && UUID_REGEX.test(trimmed);
}
